<script setup>

</script>

<template>
  <v-sheet rounded="xl" color="grey-lighten-4" class="px-5 py-7">
    <div class="d-flex align-center ga-2">
      <h2>{{ $t('gamification.configuration') }}</h2>
      <v-tooltip max-width="400">
        <template v-slot:activator="{ props }">
          <v-icon color="grey-darken-2" icon="info" v-bind="props" />
        </template>
        <b>
          {{ $t('gamification.activate_features_info') }}
        </b>
        <div>
          {{ $t('gamification.enable_qr_info') }}
        </div>
      </v-tooltip>
    </div>
    <slot></slot>
  </v-sheet>
</template>

<style scoped>

</style>